const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_615",
  "data-name": "Rectangle 615",
  width: 48.169,
  height: 71,
  fill: "#e3021c"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_489",
  "data-name": "Group 489",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M89.9,50.182H64.809a3.422,3.422,0,0,1-3.422-3.422V3.422A3.422,3.422,0,0,1,64.809,0H89.9a3.422,3.422,0,0,1,3.422,3.422v21.67H91.04V3.422A1.141,1.141,0,0,0,89.9,2.281H64.809a1.141,1.141,0,0,0-1.141,1.141V46.761a1.141,1.141,0,0,0,1.141,1.14H89.9a1.141,1.141,0,0,0,1.141-1.14V42.2h2.281v4.562A3.422,3.422,0,0,1,89.9,50.182",
  transform: "translate(-49.718)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M211.09,133.984h-2.281a3.422,3.422,0,0,1-3.422-3.422v-1.141A3.422,3.422,0,0,1,208.809,126h2.281a3.422,3.422,0,0,1,3.421,3.422v1.141a3.422,3.422,0,0,1-3.421,3.422m-2.281-5.7a1.141,1.141,0,0,0-1.141,1.141v1.141a1.141,1.141,0,0,0,1.141,1.141h2.281a1.141,1.141,0,0,0,1.141-1.141v-1.141a1.141,1.141,0,0,0-1.141-1.141Z",
  transform: "translate(-166.346 -102.049)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M222.1,75.053l-.788-2.141,3.053-1.125a1.267,1.267,0,0,0,.7-1.581l-.368-1.123a1.161,1.161,0,0,0-.591-.7.967.967,0,0,0-.774-.041l-1.23.451-.783-2.143,1.23-.451a3.263,3.263,0,0,1,2.555.131,3.422,3.422,0,0,1,1.76,2.043l.368,1.123a3.548,3.548,0,0,1-2.08,4.435Z",
  transform: "translate(-179.248 -53.454)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M211.09,163.984h-2.281a3.422,3.422,0,0,1-3.422-3.422v-1.141A3.422,3.422,0,0,1,208.809,156h2.281a3.422,3.422,0,0,1,3.421,3.422v1.141a3.422,3.422,0,0,1-3.421,3.422m-2.281-5.7a1.141,1.141,0,0,0-1.141,1.141v1.141a1.141,1.141,0,0,0,1.141,1.141h2.281a1.141,1.141,0,0,0,1.141-1.141v-1.141a1.141,1.141,0,0,0-1.141-1.141Z",
  transform: "translate(-166.346 -126.347)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M211.09,193.984h-2.281a3.422,3.422,0,0,1-3.422-3.422v-1.141A3.422,3.422,0,0,1,208.809,186h2.281a3.422,3.422,0,0,1,3.421,3.422v1.141a3.422,3.422,0,0,1-3.421,3.422m-2.281-5.7a1.141,1.141,0,0,0-1.141,1.141v1.141a1.141,1.141,0,0,0,1.141,1.141h2.281a1.141,1.141,0,0,0,1.141-1.141v-1.141a1.141,1.141,0,0,0-1.141-1.141Z",
  transform: "translate(-166.346 -150.644)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_612",
  "data-name": "Rectangle 612",
  width: 22.81,
  height: 2.281,
  transform: "translate(16.231 4.562)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_613",
  "data-name": "Rectangle 613",
  width: 20.529,
  height: 2.281,
  transform: "translate(16.231 41.058)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_614",
  "data-name": "Rectangle 614",
  width: 20.529,
  height: 2.281,
  transform: "translate(17.371 21.67)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M99.668,76.562H97.387V72h4.562v2.281H99.668Z",
  transform: "translate(-78.875 -58.314)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M101.949,148.562H97.387V144h2.281v2.281h2.281Z",
  transform: "translate(-78.875 -116.628)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M173.949,76.562h-2.281V74.281h-2.281V72h4.562Z",
  transform: "translate(-137.189 -58.314)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M173.949,148.562h-4.562v-2.281h2.281V144h2.281Z",
  transform: "translate(-137.189 -116.628)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M128.527,234h4.562a1.14,1.14,0,1,1,0,2.281h-4.562a1.14,1.14,0,0,1,0-2.281",
  transform: "translate(-103.173 -189.52)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M21.668,137.285H19.387v-20.8a7.856,7.856,0,0,1,.481-2.737l3.33-9.164a4.658,4.658,0,0,1,1.086-1.683l1.613,1.613a2.37,2.37,0,0,0-.558.858l-3.328,9.165a5.671,5.671,0,0,0-.342,1.948Z",
  transform: "translate(-15.702 -83.339)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M147.571,288.577l-.719-2.168a12.229,12.229,0,0,0,7.611-6.863l2.082.927a14.614,14.614,0,0,1-8.973,8.1",
  transform: "translate(-118.938 -226.41)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M28.414,293.306,0,284.658,2.908,274.48l28.413,8.647Zm-25.6-10.178,24.05,7.32,1.654-5.789-24.049-7.32Z",
  transform: "translate(0 -222.306)",
  fill: "#e3021c"
}));
function SvgIconPhonePalm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_490",
    "data-name": "Group 490",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.169,
    height: 71,
    viewBox: "0 0 48.169 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhonePalm);
export default __webpack_public_path__ + "static/media/icon-phone-palm.8b73de5b.svg";
export { ForwardRef as ReactComponent };